export type PathEnry = [string, string | undefined];

export const createPathFromEntries = (
  entries: PathEnry[],
  basePath: string
): string =>
  entries
    .filter(([, b]) => Boolean(b))
    .reduce(
      (acc, [key, value]) =>
        `${acc}/${key}/${encodeURIComponent(value as string)}`,
      basePath
    );
